
















import { listFactory } from '@/main/pages';

import { PageMode } from '@/main/utils/pageMode';

import { openEdit } from '@/main/router/routerPath';

import { store } from './store/list';
import { NAME, PR_RETURN_STATUS } from './constants';

export default listFactory(NAME, store).extend({
	methods: {
		editClick(event: any) {
			if (event.data.STATUS === PR_RETURN_STATUS.CLOSED) {
				openEdit(NAME, PageMode.VIEW, { id: event.data.PR_PART_RETURN_NO });
			} else {
				openEdit(NAME, PageMode.EDIT, { id: event.data.PR_PART_RETURN_NO });
			}
		},
	},
});
